import { LinkingOptions, useNavigation } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import * as Linking from 'expo-linking';
import { useEffect } from 'react';

import { BatchTicketInvestLink } from '../pages/BatchTicketInvestLink';
import { UnlockConfirmation } from '../pages/BlockList/UnlockConfirmation';
import { FixedFeeTermAcceptanceLink } from '../pages/FixedFeeTermAcceptanceLink';
import { ForgotPasswordCreate } from '../pages/ForgotPassword/Create';
import { ForgotPasswordRequest } from '../pages/ForgotPassword/Request';
import { SignIn } from '../pages/SignIn';

import { SignedOutNavigationScreenNavigationProp, SignedOutRootStackParamList } from './types';

const Stack = createNativeStackNavigator<SignedOutRootStackParamList>();

export const linking: LinkingOptions<any> = {
  prefixes: [Linking.createURL('/')],
  config: {
    initialRouteName: 'SignIn',
    screens: {
      SignIn: '/',
      ForgotPasswordRequest: '/esqueci-minha-senha',
      ForgotPasswordCreate: '/redefinir-senha',
      BatchTicketInvestLink: '/token-whatsapp/:cbid',
      FixedFeeTermAcceptanceLink: '/fee-fixo/termo/:termId',
      UnlockConfirmation: '/confirmacao/:confirmationToken',
    },
  },
};

export const SignedOut = () => {
  const navigation = useNavigation<SignedOutNavigationScreenNavigationProp>();

  useEffect(() => {
    const asyncWork = async () => {
      const initialUrl = await Linking.getInitialURL();
      const params = new URLSearchParams(initialUrl?.split('?')[1] ?? '');

      if (params.get('initialPage')) {
        const paramsObject = Array.from(params.entries())
          .filter(([key]) => key !== 'initialPage')
          .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

        navigation.navigate(
          params.get('initialPage') as keyof SignedOutRootStackParamList,
          paramsObject as any
        );
      }
    };

    asyncWork();
  }, [navigation]);

  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name="SignIn" options={{ title: 'Login' }} component={SignIn} />
      <Stack.Screen
        name="ForgotPasswordRequest"
        options={{ title: 'Esqueci minha senha' }}
        component={ForgotPasswordRequest}
      />
      <Stack.Screen
        name="ForgotPasswordCreate"
        options={{ title: 'Redefinir minha senha' }}
        component={ForgotPasswordCreate}
      />
      <Stack.Screen
        name="UnlockConfirmation"
        options={{ title: 'Confirmação' }}
        component={UnlockConfirmation}
      />
      <Stack.Screen
        name="BatchTicketInvestLink"
        options={{ title: 'Insira seu token' }}
        component={BatchTicketInvestLink}
      />
      <Stack.Screen
        name="FixedFeeTermAcceptanceLink"
        options={{ title: 'Aceite do termo' }}
        component={FixedFeeTermAcceptanceLink}
      />
    </Stack.Navigator>
  );
};
